import { EffectCallback, useEffect } from 'react';

/**
 *
 * @deprecated Not reliable in React 18. Use useEffectOnce hook instead
 */
export const useOnMount = (effect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};
